import { Tabs } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ShareSource } from '@mygpt/app';
import { useGPTStore } from '@/store';

import RobotList from './RobotList';
import DatasetList from './DatasetList';

interface AccessProps {
  shareSource?: ShareSource;
}

const Access = ({ shareSource }: AccessProps) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'robot' | 'dataset'>('robot');

  const isLocalMode = import.meta.env.VITE_MODE === 'local';
  const { assetScope } = useGPTStore();

  return (
    <div className="h-full">
      <Tabs value={activeTab} onChange={(value) => value && setActiveTab(value as 'robot' | 'dataset')}>
        <Tabs.List>
          <Tabs.Tab value="robot">{t('access.tab.robot')}</Tabs.Tab>
          {!isLocalMode && assetScope === null && <Tabs.Tab value="dataset">{t('access.tab.dataset')}</Tabs.Tab>}
        </Tabs.List>
      </Tabs>

      {activeTab === 'robot' ? <RobotList shareSource={shareSource} /> : <DatasetList shareSource={shareSource} />}
    </div>
  );
};

export default Access;
